const constants = {
    POSITIONS: {
        "top": "top",
        "bottom": "bottom"
    }
}

export default constants;